<template>
  <div class="container-results-proposals mx-auto" >
    <b-col class="filters-fixed-nav mb-1" ref="filters_fixed">
      <div class="max-width-1400 container-filters-casting-calls">
        <div class="container-button-filters-trash" style="position: relative;">
          <strong class="title-all-campaigns h3 mb-0">{{$t('creator.totalCasting')}}</strong>
          <div class="filter-btn-group">
            <button
              class="fbg-filter"
              :class="{ 'has-filters': filters_used_number > 0 }"
              @click="open_modal = !open_modal; update_modal = !update_modal;">
              <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24">
                <line x1="4" y1="6" x2="20" y2="6"/>
                <line x1="8" y1="12" x2="16" y2="12"/>
                <line x1="11" y1="18" x2="13" y2="18"/>
              </svg>
              {{$t('search.filters')}}
              <span class="fbg-badge" v-if="filters_used_number > 0">{{filters_used_number}}</span>
            </button>
            <button class="fbg-trash" @click="clearFilters" :title="$t('creator.clearFilter')">
              <svg width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                <path d="M10 11v6M14 11v6"/>
                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
              </svg>
            </button>
          </div>
          <filter-search-casting-call
            :key="filter_reset_key"
            :open_modal="open_modal"
            :filters_layout="filters_layout"
            @filter="filterAction"
          ></filter-search-casting-call>
        </div>
      </div>
    </b-col>
    <b-col class="min-height-500 text-campaign-custom">
      <div class="col-12 mb-2" v-if="$route.query.query && casting_calls.length > 0 && !loader_results">
        <span class="h5">{{$t('creator.searchBy')}} "{{$route.query.query}}"</span>
      </div>
      <div v-if="!loader_results" class="row m-0">
        <div class="grid-search-proposal w-100 position-relative" :key="loader_results">
          <div v-for="(casting_call) in casting_calls" :key="casting_call.uuid" class="responsive-xs">
            <card-casting-call class="mb-2" :casting_call="casting_call"></card-casting-call>
          </div>
          <div class="update-membership-card-category" v-if="(is_free && current_page === Math.ceil(total_casting_calls / per_page)) || (is_free && total_casting_calls === 0)">
            <p class="text-white">{{ $t('creator.updateMembershipToSeeCasting') }}</p>
            <b-button variant="light" @click="$router.push({ name: 'pages-account-setting', params: { section: 'membership' } })">{{ $t('creator.updateMembership') }}</b-button>
          </div>
        </div>    
      </div>
      <div class="w-100" v-else>
        <loader-video-brandme :text_loading="'creator.loading'" :position_class="'position-relative'"></loader-video-brandme>
      </div>
      <b-col class="empty-state-container-proposals" v-if="casting_calls.length === 0 && !loader_results">
        <no-Results 
          :title="`${$t('creator.noResults')} ${$route.query.query ? $route.query.query : ''}`"
          :subtitle="$t('creator.textFilters')"
          :text_button="$t('creator.backCampaign')"
          :btn_action="clearFilters"
          :show_icon="false"
          :class_btn="'blue-button mt-1'"
        />

      </b-col>
      <pagination-brandme 
        class="col-12 d-flex justify-content-center mt-2"
        :total_rows="total_casting_calls"
        :per_page="per_page"
        :current_page="current_page"
        @update_current_page="updateCurrentPage"
        v-if="casting_calls.length > 0"
      ></pagination-brandme>
    </b-col>
    <discover-creator-casting
      class="col-12"
      :img="getUrlCategory('home_casting_call')"
      :textInfo="$t('creator.letBrand')"
      :subtitle="$t('creator.inMinutes')"
      :textButton="$t('creator.createListing')"
      :btn_action="redirectOption"
      :disabled_btn="false"
    />

  </div>
</template>

<script>
import {
  BCol,
  BButton,
} from 'bootstrap-vue';
import casting_calls_services from '@/services/casting_calls';
import { getUrlCategory } from '@/libs/utils/urls'
const loadToastificationContent = () => import('@core/components/toastification/ToastificationContent.vue');
import { getUserData } from '@/libs/utils/user';

export default {
  name: 'castingCalls',
  components: {
    BCol,
    BButton,
    cardCastingCall: () => import('@/views/components/casting-calls/cardCastingCall.vue'),
    discoverCreatorCasting: () => import('@/views/components/proposals/cardCastingCall.vue'),
    filterSearchCastingCall: () => import('@/views/components/casting-calls/filterSearchCastingCall.vue'),
    noResults: () => import('@/views/pages/proposals/stepper/noResults.vue'),
    paginationBrandme: () => import('@/views/components/pagination/PaginationBrandme.vue'),
    LoaderVideoBrandme: () => import('@/views/components/banner/LoaderVideoBrandme.vue')
  },
  data() {
    return {
      create_proposal: false,
      getUrlCategory,
      casting_calls: [],
      outside_buttons_filter: [
        {value: 'work_for_hire', text: 'Work for Hire'},
        {value: 'job_listing', text: 'Job Listing'},
        {value: 'influencer_marketing', text: 'Influencer Marketing'},
      ],
      content_types: [],
      current_page: 1,
      filters_used_number: 0,
      per_page: 10,
      total_casting_calls: 0,
      query: undefined,
      open_modal: false,
      update_modal: false,
      filter_reset_key: 0,
      loader_results: false,
      filters_layout: [],
      filters: {},
      changFilters: false,
      filter_button_selected: {
        selected: false,
        type_button: '',
        list_button: [],
      },
    }
  },
  computed: {
    is_free() {
      return !getUserData() || (getUserData() && getUserData().current_plan.name === 'Free')
    },
  },
  created() {
    const user = getUserData()

    if (user) {
      this.create_proposal = user.meta_info && user.meta_info.vanity_name
    }
    const body = document.getElementsByTagName('body')[0];
    body.style.backgroundColor = "white";
    this.$root.$on('update_casting_calls', (selected_button) => {
      if (selected_button) this.filter_button_selected = selected_button;
      this.addFiltersFromParams();
      this.loader_results = true;
      this.getCastingCalls();
      this.$root.$emit('update_color_button_selected', this.filter_button_selected);
    });
    this.addFiltersFromParams();
    this.loader_results = true;
    this.getCastingCalls();
    setTimeout(() => {
      document.getElementsByClassName('filters-fixed-nav')[0].style.display = 'block'
    }, 500)
  },
  destroyed() {
    const body = document.getElementsByTagName('body')[0];
    body.removeAttribute('style');
    this.$store.commit('appConfig/UPDATE_NAV_MENU_HIDDEN', false);
  },
  methods: {
    updateCurrentPage(new_current_page) {
      this.current_page = new_current_page;
      this.getCastingCalls();
      
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    redirectOption() {
      if (this.create_proposal) {
        this.$router.push({ name: 'steps_proposal', params: {step: 'category'}})
      } else {
        this.$router.push({ name: 'my_work', params: { section: 'networks' } }).catch(() => {})
        loadToastificationContent().then((component) => {
          this.$toast({
            component: component.default,
            position: 'top-right',
            props: {
              title: this.$t('creator.createProfilePublic'),
              text: this.$t('creator.msjCreateProfilePublicProposals'),
              icon: 'AlertCircleIcon',
              variant: 'danger',
            }
          })
        })
      }
    },
    addContentTypeFilter(content_type_value) {
      !this.content_types.find((con) => con === content_type_value) ? this.content_types.push(content_type_value) : this.content_types = this.content_types.filter((item) => item !== content_type_value);
      this.filter_button_selected.list_button = this.filters.content_types = this.content_types;
      if (this.filter_button_selected.selected === false) this.filter_button_selected.selected = true; 
      if (this.filter_button_selected.type_button === '') this.filter_button_selected.type_button = 'content_type'
      this.getCastingCalls();
      this.loader_results = true
      this.$root.$emit('update_color_button_selected', this.filter_button_selected);
    },
    addFiltersFromParams() {
      const query = {}
      if (Object.keys(this.$route.query).length > 0) {
        if (this.$route.query.content_type) {
          if (Object.keys(this.filters).length === 0) this.filters.content_types = [this.$route.query.content_type]
          else this.filters.content_types.push(this.$route.query.content_type)          
          this.content_types.push(this.$route.query.content_type);    
        } else if (this.$route.query.query) {
          query.query = this.$route.query.query
          this.filters = query;
        } else if (this.$route.query.network) {
          query.work_types = [this.$route.query.network]
          this.filters = query;
        }
      }
    },
    clearFilters(update = true) {
      if (Object.keys(this.$route.query).length > 0) {
        this.$router.push({name: 'casting_calls'});
      }
      this.filter_button_selected.selected = false;
      this.filter_button_selected.type_button = '';
      this.filter_button_selected.list_button = []
      this.filters_layout = [];
      this.filters = {};
      this.filters_used_number = 0;
      this.current_page = 1;
      this.filter_reset_key++;
      this.content_types = [];
      this.$root.$emit('update_search_query', '');
      this.$root.$emit('update_color_button_selected', this.filter_button_selected);
      this.loader_results = true;
      if (update) this.getCastingCalls();
    },
    filterAction(filters, filters_used_number, filters_layout) {
      this.open_modal = false;
      this.update_modal = !this.update_modal;
      this.filters_used_number = filters_used_number;
      this.filters_layout = filters_layout;
      this.filters = Object.assign({}, this.filters, filters);
      this.current_page = 1;
      this.loader_results = true;
      this.getCastingCalls();
    },

    getCacheKey() {
      return `cc_cache_p${this.current_page}`
    },
    getCache() {
      const TTL = 3 * 60 * 1000 // 3 minutos
      const hasFilters = Object.values(this.filters).some(v => v !== null && v !== '' && v !== undefined)
      if (hasFilters) return null
      if (this.current_page > 2) return null
      try {
        const raw = localStorage.getItem(this.getCacheKey())
        if (!raw) return null
        const { data, ts } = JSON.parse(raw)
        if (Date.now() - ts > TTL) { localStorage.removeItem(this.getCacheKey()); return null }
        return data
      } catch (e) { return null }
    },
    setCache(data) {
      const hasFilters = Object.values(this.filters).some(v => v !== null && v !== '' && v !== undefined)
      if (hasFilters) return
      if (this.current_page > 2) return
      try {
        localStorage.setItem(this.getCacheKey(), JSON.stringify({ data, ts: Date.now() }))
      } catch (e) { /* localStorage no disponible */ }
    },
    getCastingCalls() {
      const query = {...this.filters}
      const cached = this.getCache()
      if (cached) {
        this.total_casting_calls = cached.count;
        this.casting_calls = cached.results;
        this.loader_results = false;
        // revalida en background
        casting_calls_services.getCastingCalls(query, this.per_page, this.current_page).then((response) => {
          this.total_casting_calls = response.count;
          this.casting_calls = response.results;
          this.setCache(response)
        })
        return
      }
      this.casting_calls = [];
      this.loader_results = true;
      casting_calls_services.getCastingCalls(query, this.per_page, this.current_page).then((response) => {
        this.total_casting_calls = response.count;
        this.casting_calls = response.results;
        this.loader_results = false;
        this.setCache(response)
      })
    },
    isActiveClass(value) {
      return this.content_types.find((item) => item === value) ? 'active-button-network' : '';
    },
  },
}
</script>

<style scoped lang="scss">
.update-membership-card-category {
  height: 320px;
  width: 248px;
  background: linear-gradient(#9146ff,#fa1ed2,#ea7078);
  cursor: pointer;
  border-radius: 1em;
  box-shadow: none !important;
  overflow: hidden;
  padding: 1em;
  margin-left: 1em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.aspect-ratio {
  aspect-ratio: 1 / 1;
}
.grid-search-proposal {
  display: grid;
  grid-template-columns: repeat(5, minmax(100px, 1fr));;
  grid-gap: 2rem;
  grid-auto-flow: dense;
}
@media(max-width: 1200px) {
  .grid-search-proposal {
    grid-template-columns: repeat(4, minmax(100px, 1fr));;
  }
}
@media(max-width: 1000px) {
  .grid-search-proposal {
    grid-template-columns: repeat(3, minmax(100px, 1fr));;
  }
}
@media(max-width: 700px) {
  .grid-search-proposal {
    grid-template-columns: repeat(2, minmax(100px, 1fr));;
  }
}
@media(max-width: 450px) {
  .grid-search-proposal {
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 1rem;
  }
}
.container-filters-casting-calls {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;

  .container-button-filters-trash {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 0.5rem;
    width: 100%;
    margin-bottom: 0.5em;
  }
  .title-all-campaigns {
    color: #3d3d5c;
    white-space: nowrap;
  }
  .filter-btn-group {
    display: inline-flex;
    align-items: center;
    background: #fff;
    border: 1.5px solid #e8e8f0;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    transition: box-shadow 0.2s;
    &:hover { box-shadow: 0 4px 16px rgba(115,103,240,0.1); }
  }
  .fbg-filter {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 7px 14px;
    font-size: 13px; font-weight: 700; color: #555;
    cursor: pointer; border: none; outline: none; background: transparent;
    border-right: 1.5px solid #e8e8f0;
    transition: color 0.15s, background 0.15s;
    &:hover, &:focus { background: #f7f5ff; color: #7367f0; box-shadow: none; }
    &.has-filters { color: #7367f0; }
  }
  .fbg-badge {
    background: #7367f0; color: #fff;
    border-radius: 999px; font-size: 10px; font-weight: 800;
    padding: 1px 6px; line-height: 1.5;
  }
  .fbg-trash {
    display: inline-flex; align-items: center; justify-content: center;
    width: 36px; padding: 7px 0;
    border: none; outline: none; background: transparent;
    color: #ccc; cursor: pointer;
    transition: color 0.15s, background 0.15s;
    &:hover, &:focus { background: #fff1f1; color: #e05252; box-shadow: none; }
  }
  @media(max-width: 730px) {
    justify-content: center;
  }
}
.text-campaign-custom {
  color: black;
}
.col-xl-25 {
  width: 20% !important;
}
.min-height-500 {
  min-height: 80vh;
}
.empty-state-container-proposals {
  margin: 11em 0;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
  text-align: center;
}
.max-width-1400 {
  max-width: 1400px;
  margin: 0px auto;
}
.filters-fixed-nav {
  background-color: white;
  position: sticky;
  display: none;
  width: 100%;
  left: 0;
  top: 10.7em;
  z-index: 50;
  box-shadow: 0px 10px 5px white;
  padding: 0.5em 0 0 0;
  animation: filters-fixed 600ms;
}
.container-loader-searcher {
  height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 1000;
  right: 5px;
}
.loader-table-cards {
  top: 0px;
  z-index: 10;
  display: flex;
  justify-content: center;
}
.spinner-table-searcher {
  margin-top: 10em;
  height: 6em;
  width: 6em;
  color: #acacac;
}
.button-filters {
  border: 1px solid #ced4da !important;
  display: flex;
  align-items: center;
  width: 130px !important;
  /* position: absolute; */
}
.button-trash-icon {
  display: block !important;
  width: 60px !important;
  cursor: pointer;
}
.button-filters:hover {
  background-color: #e8e8e8 !important;
}
.badge-number-filters-used {
  background-color: #7367F0;
  width: 20px;
  height: 20px;
  border-radius: 10em;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  position: absolute;
  right: 1em;
}
.outline-secondary-light {
  width: auto;
  height: 41px;
  border: 1px solid #ced4da !important;
  border-radius: 5em;
  color: #6c757d !important;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 1em;
}
.outline-secondary-light:hover {
  background-color: #e8e8e8 !important;
  transition: all 300ms;
}
.active-button-network, .active-button-network:hover {
  background-color: #d5ebe4 !important;
  color: #267e5e !important;
}
.active-button-filters {
  background-color: #d5ebe4 !important;
  color: #267e5e !important;
}
.container-results-proposals {
  max-width: 1440px;
  width: 100%;
  padding: 0 1rem;
}
.w-auto {
  width: auto !important;
}
@media(min-width: 1360px) {
  .col-25 {
    max-width: 20% !important;
  }
}
@media(max-width: 1200px) {
  .filters-fixed-nav {
    top: 5em;
  }
}
@media(max-width: 576px) {
  .responsive-xs {
    display: flex;
    justify-content: center;
  }
}
@keyframes filters-fixed {
  0% {
    transform: translateY(-200px);
    opacity: 0;
  }
  100% {
    transform: translateY(0px);
    opacity: 1;
  }
}
</style>